import { Component, Input } from '@angular/core';

@Component({
    selector: 'association-add-modal',
    template: require('./association.add.modal.component.html'),
})
export class AssociationAddModalComponent {
    @Input() item: any;
    @Input() save: Function;
    @Input() close: Function;

    comment: string = '';

    saveAssociation(): void {
        this.save(this.item, this.comment);
        this.close();
    }

    ngOnInit(): void {
        this.comment = '';
    }
}
